<template>
  <v-form v-if="layout" ref="form">
    <v-layout>
      <v-flex
        v-for="(block, blockIndex) in blocks"
        :key="blockIndex"
        xs12
        :class="{ ['sm' + (width == 0 ? 12 / blocks.length : width)]: true }"
      >
        <v-layout
          class="form-group-custom row"
          :class="{ 'custom-padding': customPadding }"
        >
          <v-flex
            v-for="(input, inputIndex) in block"
            v-if="input.show || typeof input.show == 'undefined'"
            :key="inputIndex"
            px-2
            :class="[
              input.hasHeader ? 'has-header': '',
              input.column ? `col-md-${input.column}` : '',
              input.isTwoColum ? 'col-md-6' : '',
              'col-12',
            ]"
          >
            <template v-if="input.blockName">
              <v-flex sm12 class="gray3--text font-weight-bold py-4">
                {{ input.blockName }}
              </v-flex>
            </template>
            <template v-else>
              <v-flex xs12 v-if="input.text">
                <v-subheader v-text="input.text" />
              </v-flex>
              <v-flex xs12>
                <LangRadio
                  v-if="input.type == 'langRadio'"
                  v-model="model[input.fieldName]"
                  :rules="input.rules || []"
                  :ref="input.fieldName"
                  :items="input.items"
                  class="mb-2"
                />
                <template v-else-if="input.type == 'autocomplete'">
                  <label class="titleForm" v-if="input.label">
                    {{ input.label }}
                  </label>
                  <CountryAutocomplete
                    v-model="model[input.fieldName]"
                    :rules="input.rules || []"
                    :ref="input.fieldName"
                    :placeholder="input.placeholder"
                    :items="input.items"
                  />
                </template>
                <template v-else-if="input.type == 'title'">
                  <label class="titleForm">{{ input.placeholder }}</label>
                  <v-text-field
                    outlined
                    dense
                    v-model="model[input.fieldName]"
                    :rules="input.rules || []"
                    hide-details="auto"
                  ></v-text-field>
                </template>
                <v-textarea
                  v-else-if="input.type == 'textarea'"
                  outlined
                  dense
                  v-model="model[input.fieldName]"
                  :placeholder="input.placeholder"
                  :rows="input.row"
                  :rules="input.rules || []"
                  hide-details="auto"
                  auto-grow
                ></v-textarea>
                <TextAreaCustom
                  v-else-if="input.type == 'textareaCustom'"
                  v-model="model[input.fieldName]"
                  :placeholder="input.placeholder"
                  :label="input.label || ''"
                  :row="input.row"
                  :rules="input.rules || []"
                  :rowHeight="input.rowHeight"
                />
                <template v-else-if="input.type == 'hashtags'">
                  <label class="titleForm">{{ input.label }}</label>
                  <v-combobox
                    v-model="model[input.fieldName]"
                    :placeholder="input.placeholder"
                    clearable
                    hide-selected
                    multiple
                    small-chips
                    outlined
                    dense
                  ></v-combobox>
                </template>
                <div v-else-if="input.type == 'radio'" class="d-flex align-end">
                  <label :for="input.label" v-if="input.label" class="mr-7 font-weight-bold"> {{input.label}} </label>
                  <v-radio-group
                    row
                    v-model="model[input.fieldName]"
                    hide-details="auto"
                    :class="input.class"
                  >
                    <v-radio
                      v-for="(item, radioIndex) in input.items"
                      :label="item[input.itemText]"
                      :value="item[input.itemValue]"
                      :key="radioIndex"
                      on-icon="$checkboxOn"
                      off-icon="$checkboxOff"
                      @click="uncheck(item[input.itemValue])"
                    ></v-radio>
                  </v-radio-group>
                </div>
                <FileInput
                  ref="photoInput"
                  v-else-if="input.type == 'fileInput'"
                  v-model="model[input.fieldName]"
                  :maxPhoto="input.maxPhoto"
                  :singlePhoto="singlePhoto"
                />
                <YoutubeInputSingle
                  ref="videoInput"
                  v-else-if="input.type == 'youtubeInput'"
                  v-model="model[input.fieldName]"
                  :rules="input.rules || []"
                />
                <TiptapEditor
                  v-else-if="input.type == 'editorInput'"
                  ref="editorInput"
                  :value="model[input.fieldName]"
                  :name="input.fieldName"
                  :label="input.label"
                  @setInputEditor="setInputEditor"
                />
                <template v-else-if="input.type == 'divider'">
                  <v-divider class="mb-3"></v-divider>
                </template>
                <Time
                  v-else-if="input.type == 'time'"
                  v-model="model[input.fieldName]"
                  :placeholder="input.placeholder"
                />
                <Checkbox
                  v-else-if="input.type == 'checkbox'"
                  v-model="model[input.fieldName]"
                  :label="input.label"
                  :rules="input.rules || []"
                  :key="input.key"
                />
                <SelectMultiCourse
                  v-else-if="input.type == 'multiSelect'"
                  v-model="model[input.fieldName]"
                  class="fromSearch__search"
                  :placeholder="input.placeholder"
                  iconAppend="far fa-magnifying-glass"
                  outlined
                  dense
                  :city="input.city"
                  :state="input.state"
                  :name="input.fieldName"
                  :rules="input.rules || []"
                  :label="input.label"
                  :action="input.action"
                  :multiple="input.multiple"
                />
                <DatePickerInput
                  v-else-if="input.type == 'datePicker'"
                  :placeholder="input.placeholder"
                  :rules="input.rules || []"
                  v-model="model[input.fieldName]"
                  :label="input.label"
                  :min="input.toDate && model[input.toDate]
                    ? new Date(model[input.toDate]).toISOString().slice(0, 10)
                    : new Date().toISOString().slice(0, 10)"
                  :multiple="input.multiple"
                />
                <TimeTemporary
                  v-else-if="input.type == 'timeTemporary'"
                  v-model="model[input.fieldName]"
                />
                <Telephone
                  v-else-if="input.type == 'telephone'"
                  v-model="model[input.fieldName]"
                  :label="input.label"
                  :countryCode="input.countryCode || null"
                  :phoneCode="input.countryCode || null"/>
                <div v-else-if="input.type == 'empty'"></div>
                <TextAreaTag
                  v-else-if="input.type == 'textAreaTag'"
                  v-model="model[input.fieldName]"
                />
                <template v-else>
                  <label class="titleForm" v-if="input.label">
                    {{ input.label }}
                    <v-icon v-if="input.rules" class="fas fa-star-of-life mb-2" color="red" size="8"></v-icon>
                  </label>
                  <v-text-field
                    :ref="input.fieldName"
                    v-model="model[input.fieldName]"
                    :rules="input.rules || []"
                    :disabled="disabled || input.disabled"
                    :readonly="input.readonly"
                    outlined
                    required
                    dense
                  />
                </template>
              </v-flex>
            </template>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-form>
</template>

<script>
import LangRadio from "@/components/Forms/LangRadio";
import CountryAutocomplete from "@/components/Forms/CountryAutocomplete";
import FileInput from "@/components/Forms/FileInput";
import YoutubeInputSingle from "@/components/Forms/YoutubeInputSingle";
import TiptapEditor from "@/components/Tiptap/TiptapEditor";
import Time from "@/components/Forms/Time";
import Checkbox from "@/components/Forms/Checkbox";
import SelectMultiCourse from "@/components/Forms/SelectMultiCourse";
import DatePickerInput from "@/components/Common/DatePickerInput";
import TimeTemporary from "@/components/Forms/TimeTemporary";
import TextAreaCustom from "@/components/Forms/TextAreaCustom";
import Telephone from "@/components/Forms/Telephone.vue";
import TextAreaTag from "@/components/Forms/TextAreaTag.vue";
export default {
  name: "AutoForm",
  props: {
    layout: { type: Array, default: () => [] },
    model: { type: Object, default: () => ({}) },
    disabled: { type: Boolean, default: false },
    width: { type: Number, default: 0 },
    isTwoColum: { type: Boolean, default: false },
    customPadding: { type: Boolean, default: true },
    singlePhoto: { type: Boolean, default: false },
  },
  components: {
    LangRadio,
    FileInput,
    YoutubeInputSingle,
    TiptapEditor,
    CountryAutocomplete,
    Time,
    Checkbox,
    SelectMultiCourse,
    DatePickerInput,
    TimeTemporary,
    TextAreaCustom,
    Telephone,
    TextAreaTag
  },
  data: function () {
    return {
      repeat: null,
      preSelected: null,
    };
  },
  computed: {
    blocks() {
      if (this.layout.length == 0) return [];
      if (this.layout[0] && Array.isArray(this.layout[0])) return this.layout;
      return [this.layout];
    },
  },
  methods: {
    clearForm() {
      let vm = this;
      if (vm.$refs.photoInput) vm.$refs.photoInput[0].reset(); //reset photoInput
      if (vm.$refs.videoInput) vm.$refs.videoInput[0].reset(); //reset videoInput
      if (vm.$refs.editorInput) vm.$refs.editorInput[0].reset(); //reset editorInput
      vm.$refs.form.reset(); //reset model
      vm.$refs.form.resetValidation(); // reset validate
    },
    validate() {
      return this.$refs.form.validate();
    },
    setInputEditor(data) {
      this.model[data.fieldName] = data.val;
    },
    //uncheck for radio
    uncheck: function (val) {
      if (val === this.preSelected) {
        this.model.type = false;
      }
      this.preSelected = this.model.type;
    },
  },
  watch: {
    model: {
      handler(value) {
        this.$emit("onModelChange", value);
      },
      deep: true,
    },
  },
};
</script>
<style lang="scss">
.visibility-hidden {
  visibility: hidden;
}
.form-group-custom.custom-padding .flex {
  padding-top: 0 !important;
  padding-bottom: 4px !important;
}
.formPost .v-text-field__details {
  padding: 0 !important;
}
.formPost .tiptap-vuetify-editor {
  margin-top: 2px;
  border: 1px solid rgba(0,0,0,0.38);
  border-radius: 3px;
  & > .v-card {
    box-shadow: none;
  }
}

.fromSearch__search-vlog {
  position: relative;
  .v-autocomplete__content {
    max-height: 250px !important;
  }
}
</style>
